export default __webpack_public_path__ + "static/media/cliente10_color.74378a3e.png";